import { RootState } from '../../../app';

export const selectIsSidebarOpen = ({ comments }: RootState) =>
  comments.isSideBarOpen;
export const selectSelection = ({ comments }: RootState) => comments.selection;
export const selectIsCommentCreating = ({ comments }: RootState) =>
  comments.isCommentCreating;
export const selectIsCommentEditing = ({ comments }: RootState) =>
  comments.isCommentEditing;
export const selectPendingThreads = ({ comments }: RootState) =>
  comments.pendingThreads;
export const selectResolvedThreadIds = ({ comments }: RootState) =>
  comments.resolvedThreadIds;

export const selectCommentsFlow = ({ comments }: RootState) =>
  comments.commentsFlow;
export const selectSelectedThreadIds = ({ comments }: RootState) =>
  comments.selectedThreadIds;
export const selectIsCommentReplying = ({ comments }: RootState) =>
  comments.isCommentReplying;
